// @flow
import * as React from 'react';
import styled from 'styled-components';
import { above, below } from "../../assets/css/media";
import colors from '../../assets/css/colors';
import T from '../Icons/T';
import FA from '../Icons/FA';
import S from '../Icons/S';
import C from '../Icons/C';
import D from '../Icons/D';
import V from '../Icons/V';
import E from '../Icons/E';
import Favorite from '../Icons/Favorite';
import Inactive from '../Icons/Inactive';
import Injured from '../Icons/Injured';
import Lock from '../Icons/Lock';
import Bye from '../Icons/Bye';
import NotSelected from '../Icons/NotSelected';
import Uncertain from '../Icons/Uncertain';
import Emergency from '../Icons/Emergency';
import Selected from '../Icons/Selected';
import Suspended from '../Icons/Suspended';

const HeaderWrapper = styled.div`
	width: 100%;
	box-shadow: ${colors.box_shadow};
	height: 200px;
	display: flex;
	background: #fff;
	justify-content: space-between;
	align-items: center;
	margin: 20px 0 10px;
	> div {
		height: 50px;
		display: flex;
	}
	${below.tablet`
		height: 490px;
	`};
`;

const StyledT = styled(T)`
	height: 10px;
	width: 10px;
`;

const StyledFA = styled(FA)`
	height: 10px;
	width: 10px;
`;

const StyledC = styled(C)`
	height: 10px;
	width: 10px;
	color: white;
`;

const StyledV = styled(V)`
	height: 10px;
	width: 10px;
	color: white;
`;

const StyledE = styled(E)`
	height: 10px;
	width: 10px;
	color: white;
`;

const StyledS = styled(S)`
	height: 10px;
	width: 10px;
`;

const StyledD = styled(D)`
	height: 10px;
	width: 10px;
	color: #D0021B;
`;

const TSpan = styled.span`
	border: 1px solid #DFDFDF;
	margin-right: 8px;

	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;

	height: 16px;
	width: 16px;

	padding: 3px;

	border-radius: 2px;

	> svg {
		height: 10px;
		width: 10px;
	}
`;

const FASpan = styled(TSpan)`
	background-color: #F6F6F6;
	padding: 3px 1px;

	> svg {
		width: 100%;
	}
`;

const SSpan = styled(TSpan)`
	background-color: #C0C0C0;
`;

const DSpan = styled(TSpan)`
	border: 1px solid #D0021B;
`;

const CSpan = styled(TSpan)`
	border: 1px solid #EF7D3C;
	background-color: #EF7D3C;
`;

const VSpan = styled(TSpan)`
	border: 1px solid #57ABDE;
	background-color: #57ABDE;
`;

const ESpan = styled(TSpan)`
	border: 1px solid #FC5B59;
	background-color: #FC5B59;
`;

const FavoriteSpan = styled.span`
	margin-right: 8px;
	> svg {
		margin-bottom: -4px;
		height: 16px;
		width: 16px;
	}
`;

const InactiveSpan = styled.span`
	margin-right: 8px;
	> svg {
		margin-bottom: -4px;
		height: 16px;
		width: 16px;
	}
`;

const InjuredSpan = styled.span`
	margin-right: 8px;
	margin-left: -1px;
`;

const LockSpan = styled.span`
	margin-right: 8px;
	margin-left: -1px;
`;

const LegendTableDesktop = styled.table`
	width: 90%;
	${below.tablet`
		display: none;
	`};
`;

const LegendTableMobile = styled.table`
	width: 100%;
	${above.tablet`
		display: none;
	`};
`;

const LegendTr = styled.tr`
`;

// const LegendHr = styled.hr`
// 	width: 86%;
// `;
const LegendTh = styled.th`
	font-size: 12px;
	color: #0B1C17;
	font-weight: bold;
	line-height: 18px;
	text-align: left;
	padding-left: 20px;
`;

const LegendThCoachBox = styled(LegendTh)`
	color: #6E16AA;

`;

const LegendThFirst = styled(LegendTh)`
	border-right: 1px solid #E4E7ED;
`;

const LegendTd = styled.td`
	font-size: 12px;
	line-height: 14px;
	padding-left: 20px;
	padding-top: 5px;
	vertical-align: middle;

	> svg:first-child, > span:first-child {
		margin-bottom: -4px;
	}

	> svg {
		margin-right: 8px;
		margin-left: -1px;

		height: 16px;
		width: 16px;
	}
`;

const LegendTdFirst = styled(LegendTd)`
	border-right: 1px solid #E4E7ED;
`;

const LegendTdCoachBox = styled(LegendTd)`
	color: #6E16AA;
`;

const LegendTdMobileLast = styled(LegendTd)`
	padding-bottom: 16px;
`;

const LegendSpan = styled.span`
	font-weight: bold;
	color: #003A31;
`;

const LegendSpanCoachBox = styled(LegendSpan)`
	color: #6E16AA;
`;

const SuspendWrapper = styled.div`
	display: flex;
	align-items: center;
	img {
		margin-left: -1px;
		margin-right: 7px;
	}
	div {
		box-sizing: border-box;
		padding-top: 2px;
	}
`;

const Status = styled.span`
	color: ${colors.nrlDarkGreen};
	font-weight: bold;
	font-size: 12px;
	margin-bottom: .5em;
	cursor: pointer;
	&:before {
		content: '';
		display: inline-block;
		height: 10px;
		width: 10px;
		border-radius: 50%;
		margin-right: .5em;
		background: ${colors.green};
	}
`;
const StatusSelected = styled(Selected)``;
const StatusNotSelected = styled(NotSelected)``;
const StatusUncertain = styled(Uncertain)``;
const StatusBye = styled(Bye)``;
const StatusEmergency = styled(Emergency)``;

const ScoringLink = styled.a`
	color: #0B1C17;
	text-decoration: underline;
`;

const CoachBoxLink = styled(ScoringLink)`
	color: #6E16AA;
`;



export const DraftLegend = () => (
	<HeaderWrapper>
		<LegendTableDesktop>
			<thead>
				<LegendTr>
					<LegendThFirst>Availability</LegendThFirst>
					<LegendTh>Gameplay</LegendTh>
					<LegendTh />
					<LegendThCoachBox>Fantasy Coach</LegendThCoachBox>
				</LegendTr>
			</thead>
			<tbody>
				<LegendTr>
					<LegendTdFirst />
					<LegendTd />
					<LegendTd />
				</LegendTr>
				<LegendTr>
					<LegendTdFirst>
						<StatusSelected/>
						Player <LegendSpan>has been selected (1-17)</LegendSpan>
					</LegendTdFirst>
					<LegendTd>
						<CSpan>
							<StyledC/>
						</CSpan>
						Player is your <LegendSpan>captain</LegendSpan>
					</LegendTd>
					<LegendTdFirst>
						<TSpan><StyledT /></TSpan>
						<LegendSpan>Trade</LegendSpan> player
					</LegendTdFirst>
					<LegendTdCoachBox>
						<LockSpan>
							<Lock/>
						</LockSpan>
						<LegendSpanCoachBox>Locked </LegendSpanCoachBox>
						coach feature
					</LegendTdCoachBox>
				</LegendTr>
				<LegendTr>
					<LegendTdFirst>
						<StatusNotSelected/> 
						Player <LegendSpan>has not been selected</LegendSpan>
					</LegendTdFirst>
					<LegendTd>
						<VSpan><StyledV/></VSpan>
						Player is your <LegendSpan>vice captain</LegendSpan>
					</LegendTd>
					<LegendTdFirst>
						<FASpan><StyledFA /></FASpan>Player is a <LegendSpan>free agent</LegendSpan>
					</LegendTdFirst>
				</LegendTr>
				<LegendTr>
					<LegendTdFirst>
						<Injured/>
						Player is <LegendSpan>injured</LegendSpan>
					</LegendTdFirst>
					<LegendTd>
						<ESpan>
							<StyledE/>
						</ESpan>
						Player is selected as an <LegendSpan>emergency</LegendSpan>
					</LegendTd>
					<LegendTdFirst>
						<LegendSpan><SSpan><StyledS/></SSpan>Sub/Swap</LegendSpan> player
					</LegendTdFirst>
					<LegendTd>
						<LegendSpan><CoachBoxLink href="/account/coach-settings">
							Subscribe to Coach </CoachBoxLink>
						</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTdFirst>
						<StatusUncertain/> 
						Player selection is <LegendSpan>uncertain</LegendSpan>
					</LegendTdFirst>
					<LegendTd>
						<InactiveSpan>
							<Inactive/>
						</InactiveSpan>
						Player <LegendSpan>cannot be interacted</LegendSpan> with
					</LegendTd>
					<LegendTdFirst>
						<LegendSpan><DSpan><StyledD /></DSpan>Drop</LegendSpan> player
					</LegendTdFirst>
				</LegendTr>
				<LegendTr>
					<LegendTdFirst>
						<StatusEmergency/> 
						Player is an <LegendSpan>emergency (18-21)</LegendSpan>
					</LegendTdFirst>
					<LegendTd>
						<FavoriteSpan>
							<Favorite/>
						</FavoriteSpan>
						Player is a <LegendSpan>Favourite</LegendSpan>
					</LegendTd>
					<LegendTdFirst>
						<LegendSpan><ScoringLink href="/help/guidelines#pointScoring">
							How scoring works</ScoringLink>
						</LegendSpan>
					</LegendTdFirst>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<SuspendWrapper>
							<Suspended />
							<div>
								Player is <LegendSpan>suspended</LegendSpan>
							</div>
						</SuspendWrapper>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTdFirst>
						<StatusBye/> 
						Player's club has the <LegendSpan>bye</LegendSpan>
					</LegendTdFirst>
				</LegendTr>
			</tbody>

		</LegendTableDesktop>
		<LegendTableMobile>
			<thead>
				<LegendTr>
					<LegendTh>Availability</LegendTh>
				</LegendTr>
			</thead>
			<tbody>

				<LegendTr>
					<LegendTd>
						<Status/>
						Player <LegendSpan>has been selected (1-17)</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<StatusNotSelected/> Player <LegendSpan>has not been selected</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<InjuredSpan>
							<Injured/>
						</InjuredSpan>
						Player is <LegendSpan>injured</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<SuspendWrapper>
							<Suspended /> Player is <LegendSpan>suspended</LegendSpan>
						</SuspendWrapper>

					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<StatusUncertain/> Player selection is <LegendSpan>uncertain</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<StatusEmergency/> Player is an <LegendSpan>emergency (18-21)</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTdMobileLast>
						<StatusBye/> Player's club has the <LegendSpan>bye</LegendSpan>
					</LegendTdMobileLast>
				</LegendTr>
				<LegendTr>
					<LegendTh>Gameplay</LegendTh>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<CSpan>
							<StyledC/>
						</CSpan>
						Player is your <LegendSpan>captain</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<VSpan><StyledV/></VSpan>
						Player is your <LegendSpan>vice captain</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<ESpan>
							<StyledE/>
						</ESpan>
						Player is selected as an <LegendSpan>emergency</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<InactiveSpan>
							<Inactive/>
						</InactiveSpan>
						Player <LegendSpan>cannot be interacted</LegendSpan> with
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<FavoriteSpan>
							<Favorite/>
						</FavoriteSpan>
						Player is a <LegendSpan>Favourite</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<TSpan><StyledT /></TSpan>
						<LegendSpan>Trade</LegendSpan> player
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<FASpan><StyledFA /></FASpan>Player is a <LegendSpan>free agent</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<LegendSpan><SSpan><StyledS/></SSpan>Sub/Swap</LegendSpan> player
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<LegendSpan><DSpan><StyledD /></DSpan>Drop</LegendSpan> player
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<LegendSpan><ScoringLink href="/help/guidelines#pointScoring">
						How scoring works</ScoringLink>
						</LegendSpan>
					</LegendTd>
				</LegendTr>
				<LegendTr>
					<LegendThCoachBox>Fantasy Coach</LegendThCoachBox>
				</LegendTr>
				<LegendTr>
					<LegendTdCoachBox>
						<LockSpan>
							<Lock/>
						</LockSpan>
						<LegendSpanCoachBox>Locked </LegendSpanCoachBox>
						coach feature
					</LegendTdCoachBox>
				</LegendTr>
				<LegendTr>
					<LegendTd>
						<LegendSpan><CoachBoxLink href="/account/coach-settings">
						Subscribe to Coach </CoachBoxLink>
						</LegendSpan>
					</LegendTd>
				</LegendTr>
			</tbody>
		</LegendTableMobile>
	</HeaderWrapper>
);

export default DraftLegend;


// WEBPACK FOOTER //
// ./src/components/DraftLegend/index.js